import { getWebroot } from '../utils/webroot';

interface WebrootState {
  webroot: string;
  loading: boolean;
  error: string | null;
}

/**
 * Custom hook for getting webroot configuration with runtime fallback
 */
export function useWebroot(): WebrootState {
  const webroot = getWebroot();
  
  return {
    webroot,
    loading: false,
    error: null
  };
}